module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [(_vm.icon) ? _c('div', [_c('div', {
    class: ['ico-' + _vm.icon + ' epic mb-2']
  })]) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('h3', [_vm._v("\n        " + _vm._s(_vm.product.code) + " |\n        "), (_vm.reservation.customer.name) ? _c('span', [_vm._v(_vm._s(_vm.reservation.customer.name))]) : _vm._e(), _vm._v(" "), (_vm.reservation.customer.surname) ? _c('span', [_vm._v(_vm._s(_vm.reservation.customer.surname))]) : _vm._e(), _vm._v(" |\n        " + _vm._s(_vm.product.name) + " |\n\n        "), _c('date-and-time', {
    attrs: {
      "reservation": _vm.reservation
    }
  })], 1), _vm._v(" "), (_vm.reservation.status === -5) ? _c('div', {
    staticClass: "radius-large p-2 bg-color-6 d-inline-block normal"
  }, [_vm._v("\n        This reservation has been canceled\n    ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78417f8a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/view/ViewHeader.vue
// module id = 1567
// module chunks = 0